export class UserIdFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "equals",
            "baseName": "Equals",
            "type": "string",
            "format": ""
        },
        {
            "name": "_in",
            "baseName": "In",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "NotIn",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UserIdFilters.attributeTypeMap;
    }
    constructor() {
    }
}
